import { render, staticRenderFns } from "./pos-session-report.vue?vue&type=template&id=1c08e1e8&scoped=true&"
import script from "./pos-session-report.ts?vue&type=script&lang=ts&"
export * from "./pos-session-report.ts?vue&type=script&lang=ts&"
import style0 from "./pos-session-report.scss?vue&type=style&index=0&id=1c08e1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c08e1e8",
  null
  
)

export default component.exports